import { render, staticRenderFns } from "./PB-Header.vue?vue&type=template&id=084dcf44&scoped=true&"
import script from "./PB-Header.vue?vue&type=script&lang=js&"
export * from "./PB-Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084dcf44",
  null
  
)

export default component.exports